import { Container } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

interface ITransactionDetailsCardProps {
  title?: string;
  children: React.ReactNode | React.ReactChild[];
}

@inject('translateStore')
@observer
export default class TransactionDetailsCard extends React.Component<ITransactionDetailsCardProps> {
  public render(): JSX.Element {
    return (
      <React.Fragment>
        {this.props.title && (
          <h3 className="h4">
            <b id={'payment-history-details-title'}>{this.props.title}</b>
          </h3>
        )}
        <Container>{this.props.children}</Container>
      </React.Fragment>
    );
  }
}
